<template>
  <div class="drawer-wrapper">
    <el-drawer :title="title"
            :wrapperClosable="true"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :size="size"
            :before-close="handleClose"
            :onCancel="AddNone"
            :onConfirm="addPush"
    >
      <div class="demo-drawer__content">
        <el-form :model="addFrom" size="medium"  class="mt35" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="角色组" :label-width="formLabelWidth" v-if="formVisible">
                  <el-select v-model="addFrom.group" placeholder="请选择角色组" clearable style="width: 90%;" :disabled="EditFlag">
                    <el-option v-for="dict in appidList" :key="dict.dictValue" :label="dict.name"
                               :value="dict.id"/>
                  </el-select>
                </el-form-item>
              </transition>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="用户名" prop="username" :label-width="formLabelWidth" v-if="formVisible">
                  <el-input v-model="addFrom.username" placeholder="请输入用户名称" style="width: 90%;" clearable :disabled="EditFlag"></el-input>
                </el-form-item>
              </transition>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="昵称" prop="nickname" :label-width="formLabelWidth" v-if="formVisible">
                  <el-input v-model="addFrom.nickname" placeholder="请输入昵称" clearable style="width: 90%;"></el-input>
                </el-form-item>
              </transition>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="真实姓名" prop="real_name" :label-width="formLabelWidth" v-if="formVisible">
                  <el-input v-model="addFrom.real_name" placeholder="请输入真实姓名" clearable style="width: 90%;"></el-input>
                </el-form-item>
              </transition>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="密码" prop="password" :label-width="formLabelWidth" v-if="formVisible">
                  <el-input v-model="addFrom.password" placeholder="请输入密码" clearable style="width: 90%;"></el-input>
                </el-form-item>
              </transition>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="邮箱" :label-width="formLabelWidth" v-if="formVisible">
                  <el-input v-model="addFrom.email" placeholder="请输入邮箱" clearable style="width: 90%;"></el-input>
                </el-form-item>
              </transition>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="手机号" prop="mobile" :label-width="formLabelWidth" v-if="formVisible">
                  <el-input v-model="addFrom.mobile" placeholder="请输入手机号" clearable style="width: 90%;"></el-input>
                </el-form-item>
              </transition>
            </el-col>
<!--            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">-->
<!--              <transition name="fade-slide">-->
<!--                <el-form-item label="部门联系人" :label-width="formLabelWidth" v-if="formVisible">-->
<!--                  <el-input v-model="addFrom.contact_person" placeholder="请输入部门联系人（多个用/隔开）" clearable style="width: 90%;"></el-input>-->
<!--                </el-form-item>-->
<!--              </transition>-->
<!--            </el-col>-->
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <transition name="fade-slide">
                <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width: 90%;" v-if="formVisible">
                  <el-radio-group v-model="addFrom.status">
                    <el-radio :label="1">正常</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                  </el-radio-group>
                </el-form-item>
              </transition>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush" :loading="submitLoading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {administratorsAPI} from '@/api/account/administrators';
import {processErrors} from "@/utils/errorHandler";
import Drawer from "@/components/DrawerComponent/index";

export default {
  props: ['dialogVisible', "editID"],
  components: {
    Drawer,
  },
  data() {
    return {
      page: {
        s:"/admin/group/option",
      },
      formLabelWidth: "140px",
      title: "新增",
      addFrom: {
        username: "",
        nickname: "",
        real_name: "",
        password: "",
        email: "",
        mobile: "",
        contact_person: "",
        status: 1,
        id: "",
        group: ""
      }, rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 6, max: 20, pattern: /^[a-zA-Z0-9_-]{6,20}$/, message: '用户名6-20位包含数字和字母', trigger: 'blur'},

        ],
        nickname: [
          {required: true, message: '请输入昵称', trigger: 'blur'},
        ],
        real_name: [
          {required: true, message: '请输入真实姓名', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, pattern: /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/, message: '密码至少6位包含数字和字母', trigger: 'blur'},
        ],
        mobile: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
      },
      nameRole: "优化师",
      appidList: [],
      EditFlag: false,
      size:"50%",
      submitLoading: false,
      formVisible: false,
    };
  },
  created() {
    this.getroleList()
  },
  methods: {
    handleClose(done) {
      this.$emit('AddOk');
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },
    getroleList() {
      let api = administratorsAPI()
      api.roleList(this.page).then(res => {
        if (res.code == 0) {
          this.appidList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
    addPush() {
      if (this.submitLoading) return;
      
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          let api = administratorsAPI()
          api.adminAdded(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          }).finally(() => {
            this.submitLoading = false;
          })
        } else {
          return false;
        }
      });
    }
  },

  mounted() {
    if (this.editID) {
      let api = administratorsAPI()
      api.detailsList(this.editID).then(res => {
        if (res.code == 0) {
          this.EditFlag = true
          this.title = "编辑"
          this.rules.password = []
          this.addFrom = {
            username: res.data.username,
            nickname: res.data.nickname,
            real_name: res.data.real_name || "",
            password: res.data.show_password || "",
            email: res.data.email,
            mobile: res.data.mobile,
            contact_person: res.data.contact_person || "",
            status: res.data.status,
            id: res.data.id,
            group: res.data.group_id
          }
          this.$nextTick(() => {
            this.formVisible = true;
          });
        } else {
          processErrors(res);
        }
      })
    } else {
      this.formVisible = true;
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}

.fade-slide-enter-active {
  transition: all 0.4s ease;
}

.fade-slide-enter {
  transform: translateY(-20px);
  opacity: 0;
}
</style>